module.exports = __webpack_public_path__ + "img/icon-twitter.00f456a3.svg";